<app-location-details-modal 
  *ngIf="isModalOpen" 
  (close)="closeModal()"
  (save)="onLocationSaved($event)"
  [locations]="locations">
</app-location-details-modal>
<app-delete-location-modal 
  *ngIf="isDeleteModalOpen" 
  [location]="selectedLocation"
  (close)="closeDeleteModal()"
  (confirm)="onDeleteConfirm($event)">
</app-delete-location-modal>
    <div class="setting">
      <h1>{{ userProfile?.role === 'admin' ? 'Settings' : 'Profile' }}</h1>
      <p>View and edit your account info here.</p>
      <button class="btn btn-primary btn-medium add-location-button" *ngIf="activeTab === 'Location Management'" (click)="openModal()"> <img src="assets/images/package/plus.svg" alt="Add Location" class="add-location-icon"> Add Location</button>
    </div>
    <app-settings
      [userProfile]="userProfile"
      [activeTab]="activeTab"
      (tabChange)="onTabChange($event)"
    ></app-settings>
    <div class="content-container">
      <div class="content" *ngIf="activeTab === 'User Profile'">
        <app-collapsible-card #personalDetailsCard title="Personal Details" [isCollapsed]="openCard !== 'Personal Details'"
          (toggled)="toggleCard('Personal Details')"  [showEditButton]="true" (editClicked)="onEditProfile('Personal Details')">
          <app-profile-details #profileDetails [userProfile]="userProfile" (cancelClicked)="onCancelProfileEdit('Personal Details')"></app-profile-details>
        </app-collapsible-card> 
        <app-collapsible-card #passwordCard title="Password" [isCollapsed]="openCard !== 'Password'"
          (toggled)="toggleCard('Password')" [showEditButton]="true" [isPasswordCard]="true" (editClicked)="onEditProfile('Password')">
          <app-password-settings #passwordSettings (cancelClicked)="onCancelProfileEdit('Password')"></app-password-settings>
        </app-collapsible-card>
      </div>
      <div class="content" *ngIf="activeTab === 'Account Settings'">
        <app-collapsible-card title="Plan Details" [isCollapsed]="openCard !== 'Plan Details'"
          (toggled)="toggleCard('Plan Details')">
          <app-plan-details></app-plan-details>
        </app-collapsible-card>
        <app-collapsible-card title="Invoice History" [isCollapsed]="openCard !== 'Invoice History'"
          (toggled)="toggleCard('Invoice History')">
          <app-team-members></app-team-members>
        </app-collapsible-card>
      </div>
      <div class="content" *ngIf="activeTab === 'Business Profile'">
        <app-collapsible-card #businessDetailsCard title="Business Details" [isCollapsed]="openCard !== 'Business Details'"
          (toggled)="toggleCard('Business Details')" [showEditButton]="userProfile?.role === 'admin' ? true : false" (editClicked)="onEditProfile('Business Details')">
          <app-business-profile #businessProfile   (cancelClicked)="onCancelProfileEdit('Business Details')"></app-business-profile>
        </app-collapsible-card>
      </div>
      <div class="content" *ngIf="activeTab === 'Location Management'">
        <div class="location-container">
          <div *ngIf="locations.length === 0">
            <app-empty-location (addLocation)="openModal()"></app-empty-location>
          </div>
          <div *ngIf="locations.length > 0">
            <app-location-management [locations]="locations" (locationSelected)="onLocationSelected($event)"></app-location-management>
           
          </div>
          <div *ngIf="locations.length > 0">
            <app-collapsible-card #addressCard title="Address" [isCollapsed]="openCard !== 'Address'"
              (toggled)="toggleCard('Address')" [showEditButton]="userProfile?.role === 'admin' ? true : false" (editClicked)="onEditProfile('Address')">
              <app-address-form #addressForm (cancelClicked)="onCancelProfileEdit('Address')" (locationUpdated)="onLocationUpdated($event)" [locationDetails]="selectedLocationDetails"></app-address-form>
            </app-collapsible-card>
            <app-collapsible-card #contactDetailsCard title="Contact Details" [isCollapsed]="openCard !== 'Contact Details'"
              (toggled)="toggleCard('Contact Details')" [showEditButton]="userProfile?.role === 'admin' ? true : false" (editClicked)="onEditProfile('Contact Details')">
              <app-contact-details #contactDetails (cancelClicked)="onCancelProfileEdit('Contact Details')" (locationUpdated)="onLocationUpdated($event)" [locationDetails]="selectedLocationDetails"></app-contact-details>
            </app-collapsible-card>
            <app-collapsible-card #operatingHoursCard title="Operating Hours" [showEditButton]="userProfile?.role === 'admin' ? true : false" (editClicked)="onEditProfile('Operating Hours')" [isCollapsed]="openCard !== 'Operating Hours'"
              (toggled)="toggleCard('Operating Hours')">
              <app-operating-hours #operatingHours [locationDetails]="selectedLocationDetails" (cancelClicked)="onCancelProfileEdit('Operating Hours')" (locationUpdated)="onLocationUpdated($event)" [locations]="locations"></app-operating-hours>
            </app-collapsible-card>
            <button class="btn btn-outlined btn-medium delete-location-button" (click)="openDeleteModal()"> <img src="assets/images/trash.svg" alt="Delete Location" class="add-location-icon"> Delete Location</button>
          </div>
        </div>
      </div>
      <div class="content" *ngIf="activeTab === 'Payment'">
        <app-payment-settings [locations]="locations"></app-payment-settings>
      </div>
      <div class="content" *ngIf="activeTab === 'Terminal' && userProfile?.role === 'admin'">
        <app-terminal-settings [locations]="locations"></app-terminal-settings>
      </div>
      <div class="content help-support" *ngIf="activeTab === 'Help & Support'">
        <app-collapsible-card title="Contact Us" [isCollapsed]="false" [isFixedOpen]="true">
          <p>Need help? Get in touch with our support team at a <a
              href="mailto:support&#64;way.com">support&#64;way.com</a> or call <a
              href="tel:408-598-3338">408-598-3338</a></p>
        </app-collapsible-card>
        <app-collapsible-card title="Terms & Policies" [isCollapsed]="false" [isFixedOpen]="true">
          <p>Review our <a href="https://www.way.com/aboutUs/userAgreement" target="_blank" rel="noopener noreferrer">Terms & Conditions</a> and <a href="https://www.way.com/aboutUs/privacyPolicy" target="_blank" rel="noopener noreferrer">Privacy Policy</a> to understand how we
            handle your data and the rules for using our services.</p>
        </app-collapsible-card>
      </div>
    </div>

